export { default as EmbeddedCarousel } from './EmbeddedCarousel';
